import { render, staticRenderFns } from "./RegisterWithPassword.vue?vue&type=template&id=b6081c52"
import script from "./RegisterWithPassword.vue?vue&type=script&lang=js"
export * from "./RegisterWithPassword.vue?vue&type=script&lang=js"
import style0 from "./RegisterWithPassword.vue?vue&type=style&index=0&id=b6081c52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports